<div
  class="ui-g-12 ui-md-10"
  [ngClass]="{'touchpoint-error': invalidSubmit && (!selectedTouchpoints || selectedTouchpoints.length === 0)}"
  *ngIf="!disableTouchpoint">
  <div
    class="ui-g-12 ui-md-6"
    *ngFor="let tp of touchpoints"
    style="padding-top: 0;"
    [ngClass]="{'stores-error': invalidSubmit && tpWithoutStores?.indexOf(tp.value) !== -1 && selectedTouchpoints?.indexOf(tp.value.toString()) !== -1}">
    <div class="ui-g-12 ui-md-8">
      <p-checkbox
        class="tp-checkbox"
        name="tpGroup"
        value="{{tp.value}}"
        label="{{tp.label}}"
        [(ngModel)]="selectedTouchpoints"
        (onChange)="onTouchpointSelection($event, tp)">
      </p-checkbox>
    </div>
    <div class="ui-g-12 ui-md-4">
      <p-button
        *ngIf="tp.flg_offline === '1'"
        class="tp-detail-btn"
        pTooltip="{{ 'campaign.storesDetail' | translate }}"
        icon="fa fas fa-building"
        styleClass="ui-button-info"
        (onClick)="showTpDetails(tp)"
        [disabled]="selectedTouchpoints.indexOf(tp.value.toString()) === -1"
      ></p-button>
      <!-- Generato button nascosto per non far saltare la griglia -->
      <p-button
        *ngIf="tp.flg_offline === '0'"
        class="tp-hidden-btn">
      </p-button>
    </div>
    <div class="ui-g-12" *ngIf="invalidSubmit && tpWithoutStores?.indexOf(tp.value) !== -1 && selectedTouchpoints?.indexOf(tp.value.toString()) !== -1">
      <span class="input-error-notification" >{{ 'campaign.touchpointStoresValidator' | translate }}</span>
    </div>
  </div>
</div>
<!-- <div class="ui-g-12" *ngIf="invalidSubmit && (!selectedTouchpoints || selectedTouchpoints.length === 0)">
  <span class="input-error-notification">{{ 'campaign.touchpointValidator' | translate }}</span>
</div> -->
<div class="ui-g-12 ui-md-10">
  <app-campaign-store-list
    [touchpoint]="tpToShow"
    [invalidSubmit]="invalidSubmit">
  </app-campaign-store-list>
</div>



// WEBPACK FOOTER //
// ./src/app/views/campaign-2.0/campaign-touchpoints/campaign-touchpoints.component.html